import { darkTheme, theme, themeTokens } from './theme';

export const BAYUT_KEY = 'bayut';

const appTheme = Object.freeze({ key: BAYUT_KEY, darkTheme, ...theme, themeTokens });

export default appTheme;
